import React, { useCallback, useEffect, useState } from 'react';

import { Avatar, Image, Modal, Table, Typography } from 'antd';
import { RowSelectionType, TableRowSelection } from 'antd/lib/table/interface';

import { ExclamationCircleOutlined, SearchOutlined } from '@ant-design/icons';
import LoadingComponents from '@components/LoadingComponents';
import TableFilters from '@components/TableFilters';
import { useCustomer } from '@hooks/CustomerContext';
import { useOrder } from '@hooks/OrdersContext';
import { Order } from '@models/Order';
import { CustomButton } from '@styles/globals';
import { formatCnpj, formatCpf } from '@utils/index';

import * as S from './styles';

const { Text } = Typography;

interface ChangeCustomerFormProps {
  currentCustomer: number;
  actualOrder: Order;
  handleCloseCustomerModal: Function;
  option: string;
}
const ChangeCustomerForm: React.FC<ChangeCustomerFormProps> = ({
  currentCustomer: initialCustomer,
  actualOrder,
  handleCloseCustomerModal,
  option,
}) => {
  const { customers, loadingCustomers, loadCustomersPaginated } = useCustomer();
  const { updateOrderUsingMerp, loadInProgressOrders, loadAttendedOrders, loadCanceledOrders } = useOrder();

  const [selectedCustomer, setSelectedCustomer] = useState<number>(initialCustomer);
  const [localCustomers, setLocalCustomers] = useState<any[]>([]);

  useEffect(() => {
    if ((customers?.length ?? 0) == 0) loadCustomersPaginated(0, 'APPROVED', null, 10000);
  }, []);

  useEffect(() => {
    if (customers) setLocalCustomers(customers);
    else loadCustomersPaginated(0, 'APPROVED', 10000);
  }, [customers]);

  const getCustomerImage = (photoUrl: string, name: string) => {
    if (photoUrl)
      return (
        <Image
          src={photoUrl}
          width={30}
          style={{ borderRadius: '12px' }}
          preview={false}
          fallback="data:image/png;base64,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"
        />
      );

    return <Avatar style={{ backgroundColor: 'var(--primary-color)', verticalAlign: 'middle' }}>{name[0]}</Avatar>;
  };

  const columns = [
    {
      dataIndex: 'code',
      title: 'Cód.',
      width: '100px',
      align: 'center' as 'center',
      sorter: (representanteA: any, representanteB: any) => representanteA.code - representanteB.code,
    },
    {
      title: 'Lojista',
      render: (record: any) => (
        <div>
          {getCustomerImage(record.photoUrl, record.name)}
          <Text className="ml-3">{record.name}</Text>
        </div>
      ),
      filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }: any) => (
        <TableFilters
          inputPlaceholder={'Filtrar pelo nome do lojista'}
          inputValue={selectedKeys[0]}
          onChangeInputValue={setSelectedKeys}
          onFilter={confirm}
          onClearFilters={clearFilters}
        />
      ),
      filterIcon: () => <SearchOutlined />,
      onFilter: (value: any, record: any) => {
        return record.name ? record.name.toString().toLowerCase().includes(value.toLowerCase()) : '';
      },
      sorter: (representanteA: any, representanteB: any) =>
        representanteA.name.trim().localeCompare(representanteB.name.trim()),
    },
    {
      title: 'CNPJ/CPF',
      dataIndex: 'cpfCnpj',
      render: (value: string) => <Text>{value?.length > 11 ? formatCnpj(value) : formatCpf(value)}</Text>,
      sorter: (representanteA: any, representanteB: any) => {
        if (representanteA.cpfCnpj && representanteB.cpfCnpj) {
          return representanteA.cpfCnpj.localeCompare(representanteB.cpfCnpj);
        }
        return 0;
      },
    },
  ];

  const onChangeRowSelection = async (selectedRowKeys: any[]) => {
    setSelectedCustomer(selectedRowKeys[0]);
  };

  const rowSelection: TableRowSelection<RowSelectionType> = {
    columnTitle: 'Vinculado',
    type: 'radio',
    selectedRowKeys: [selectedCustomer],
    onChange: onChangeRowSelection,
  };

  const onSubmitCustomers = useCallback(() => {
    console.log(customers);
    const customer = customers?.filter((rep) => rep.code == selectedCustomer)[0];
    console.log(customer);
    const address = customer?.addresses[0];
    console.log(address);

    Modal.confirm({
      title: `Tem certeza que deseja atualizar o lojista do pedido?\n `,
      content: (
        <Text>
          {` O novo endereço do pedido será:\n ${address.address}, ${address.addressNumber} - ${address.cep}, 
          ${address.cityName} - ${address.stateAbbreviation}`}
        </Text>
      ),
      icon: <ExclamationCircleOutlined />,
      okText: 'Atualizar',
      cancelText: 'Cancelar',
      async onOk() {
        await updateOrderUsingMerp({
          ...actualOrder,
          customerCode: selectedCustomer,
          customerCpfCnpj: customer.cpfCnpj,
          customerName: customer.name,
          address: address,
        });
        actualOrder = {
          ...actualOrder,
          customerCode: selectedCustomer,
          customerCpfCnpj: customer.cpfCnpj,
          customerName: customer.name,
          shippingAddress: address,
        };
        if (option === 'attended') {
          await loadAttendedOrders();
        }

        if (option === 'canceled') {
          await loadCanceledOrders();
        }

        if (option === 'in-progress') {
          await loadInProgressOrders();
        }
        handleCloseCustomerModal();
      },
    });
  }, [selectedCustomer]);

  if (loadingCustomers) return <LoadingComponents />;

  return (
    <S.CustomForm layout="vertical">
      <S.ScrollPanel>
        <Table
          className="mt-4 mb-4"
          columns={columns}
          dataSource={localCustomers}
          rowKey={(record) => record.code}
          scroll={{ x: 800 }}
          rowSelection={rowSelection}
          rowClassName={(row) => {
            if (selectedCustomer == row.code) return 'hide';
            else return '';
          }}
        />
      </S.ScrollPanel>
      <CustomButton onClick={onSubmitCustomers} type="primary" className="w-100">
        SALVAR
      </CustomButton>
    </S.CustomForm>
  );
};

export default ChangeCustomerForm;
